
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download-brochure",
      function () {
        return require("private-next-pages/download-brochure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download-brochure"])
      });
    }
  